import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
  moduleId: module.id,
  selector: 'icon-car',
  template: `
    <ng-template #template>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="{{ class }}"
      >
        <!-- Body of the car -->
        <path d="M3 12h18l-1.5-4.5a2 2 0 0 0-1.9-1.5H6.4a2 2 0 0 0-1.9 1.3L3 12z" />

        <!-- Windows -->
        <path d="M6.5 6.5h11l1.5 5h-14z" />

        <!-- Wheels -->
        <circle cx="7" cy="17" r="1.5" />
        <circle cx="17" cy="17" r="1.5" />

        <!-- Front light -->
        <line x1="21" y1="12" x2="22" y2="12" />

        <!-- Rear light -->
        <line x1="2" y1="12" x2="3" y2="12" />
      </svg>
    </ng-template>
  `,
})
export class IconCarComponent {
  @Input() class: any = '';
  @ViewChild('template', { static: true }) template: any;
  constructor(private viewContainerRef: ViewContainerRef) {
    // do nothing
  }
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
